module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.items.length) ? _c('MentoringProgramsList', {
    attrs: {
      "items": _vm.items
    }
  }) : _c('Warning', [_c('p', [_vm._v(_vm._s(_vm.warningText))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e6ca946","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/mentoring/views/allprograms/MentoringAllPrograms.vue
// module id = 8589d15e70ce1b71901e
// module chunks = 62